import tw, { styled } from 'twin.macro'
import type { TTextAreaProps } from './interface'

export const StyledLabel = styled.label(() => [tw`text-gray-300 px-6`])

const TextAreaBase = tw`w-full min-h-32 rounded-3xl px-6 h-12 border-none transition duration-300 ease-in-out`
const TextAreaErrorStyle = tw`border-red-500`

export const getTextAreaStyle = (isError: TTextAreaProps['isError']) => isError && TextAreaErrorStyle

export const StyledTextArea = styled.textarea(({ isError }: TTextAreaProps) => [
  TextAreaBase,
  tw`px-6 py-4 font-body focus:outline-none border-none`,
  getTextAreaStyle(isError),
])
